import { Navigate } from 'react-router-dom';

import { getDefaultPath } from '@constant/routes';
import { useAuth } from '@context/auth-context';
import type { ModuleRouteProps } from '@type/routing';

export default function ModuleRoute({ module, children }: ModuleRouteProps) {
  const { canAccess, user } = useAuth();

  if (!canAccess(module)) {
    return <Navigate to={getDefaultPath(user)} replace />;
  }

  return children;
}
